import { render, staticRenderFns } from "./Wares.vue?vue&type=template&id=276a980c&scoped=true&"
import script from "./Wares.vue?vue&type=script&lang=js&"
export * from "./Wares.vue?vue&type=script&lang=js&"
import style0 from "./Wares.vue?vue&type=style&index=0&id=276a980c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276a980c",
  null
  
)

export default component.exports